// eslint-disable-next-line no-unused-vars
import request from '@/service/http'

export function searchInit (data) {
    return request({
      url: '/api/studentSign/searchInit',
      method: 'post',
      data,
    })
}

export function searchList (data) {
    return request({
      url: '/api/studentSign/searchList',
      method: 'post',
      data,
    })
}

export function getClassSignDetail (data) {
  return request({
    url: '/api/studentSign/getClassSignDetail',
    method: 'post',
    data,
  })
}

export function addStudentSign (data) {
  return request({
    url: '/api/studentSign/studentSignSave',
    method: 'post',
    data,
  })
}

export function getSignList (data) {
  return request({
    url: '/api/studentSign/getSignList',
    method: 'post',
    data,
  })
}


